import { render } from "./product-unit-sales.vue?vue&type=template&id=63995935&scoped=true"
import script from "./product-unit-sales.vue?vue&type=script&lang=js"
export * from "./product-unit-sales.vue?vue&type=script&lang=js"

import "./product-unit-sales.vue?vue&type=style&index=0&id=63995935&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63995935"]])

export default __exports__